<template>
    <div class="mainBox">
        <div class="boxTop">
            <h5>州市诚信指数排行</h5>
            <div class="sortBtn" @click="handleUpOrDown">
                <span>排序</span>
                <div>
                    <img src="../../../assets/image/ic_px.png" v-show="isUpSort">
                    <img src="../../../assets/image/ic_px_dx.png" v-show="!isUpSort">
                </div>
            </div>
        </div>
        <ul class="rankingList">
            <li v-for="(item, index) in proviceListData" :key="index">
                <span>{{(1*index+1)+"、"}}</span>
                <p>{{item.regionName}}</p>
                <span>{{item.score+"分"}}</span>
            </li>
        </ul>
        <router-link class="toMore" to="/integrity/districtRanking">
            <span>查看更多排名</span>
            <img src="../../../assets/image/t-right.png">
        </router-link>

    </div>
</template>

<script>
    export default {
        name: 'ProvinceRanking',
        props: ['proviceListData'],
        data () {
            return {
                isUpSort: true,
                sortData: []
            }
        },
        mounted () {
            this.sortData = this.upData;
        },
        methods: {
            handleUpOrDown () {
                this.isUpSort = !this.isUpSort;
                this.$emit('changeProviceListData')
            }
        }
    }
</script>

<style lang="less" scoped>
    .mainBox{
        width:100%;
        padding: 24px 16px;
        background: #fff;
    }

    .boxTop{
        margin-bottom: 22px;
    }

    .boxTop::after{
        content: "";
        display: block;
        clear: both;
    }

    .boxTop>h5{
        font-size: 14px;
        font-weight: bold;
        float: left;
    }

    .boxTop>.sortBtn{
        float: right;
    }

    .sortBtn{
        text-align: center;
        line-height: 12px;
    }

    .sortBtn::after{
        content: "";
        display: block;
        clear: both;
    }

    .sortBtn>span{
        margin-right: 3px;
        float: left;
    }

    .sortBtn>div{
        width: 14px;
        height: 12px;
        background-color: #000;
        float: left;
    }

    .sortBtn>div>img{
        width: 100%;
        height: 100%;
    }

    .rankingList{
        margin-bottom: 12px;
    }

    .rankingList>li{
        color: #666;
    }

    .rankingList>li::after{
        content: "";
        display: block;
        clear: both;
    }

    .rankingList>li>span:first-child{
        line-height: 35px;
        float: left;
    }

    .rankingList>li>span:last-child{
        line-height: 35px;
        float: right;
    }

    .rankingList>li>p{
        max-width: 270px;
        line-height: 35px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        float: left;
    }

    .toMore{
        width: 100%;
        margin: 0 auto;
        text-align: center;
        color: #9B9B9B;
        display: flex;
        justify-content: center;
    }

    .toMore::after{
        content: "";
        display: block;
        clear: both;
    }

    .toMore>span{
        float: left;
    }

    .toMore>img{
        width: 8px;
        height: 8px;
        margin-left: 2px;
        float: left;
        position: relative;
        top: 3px;
    }
</style>
